import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface ConfidenceBadgeProps {
  confidence: number;
  className?: string;
}

const COLORS = {
  positive: { backgroundColor: "#40C057", color: "white" },
  negative: { backgroundColor: "#FF646C", color: "white" },
  neutral: { backgroundColor: "#F59E0B", color: "white" },
} as const;

export function ConfidenceBadge({ confidence, className }: ConfidenceBadgeProps) {
  const style =
    confidence >= 80 ? COLORS.positive
    : confidence >= 50 ? COLORS.neutral
    : COLORS.negative;

  return (
    <Badge className={cn("border-transparent", className)} style={style}>
      Confidence: {confidence}%
    </Badge>
  );
}
